/* Larabico - mostra/nasconde il flag quando cambia la variante
   Percorso: assets/lbh-free-shipping.js */
(function () {
  if (window.lbhFlagInit) return;
  window.lbhFlagInit = true;

  function update(sectionId, price) {
    document
      .querySelectorAll('.lbh-flag[data-section-id="' + sectionId + '"]')
      .forEach(function (el) {
        var min = parseInt(el.getAttribute('data-min'), 10) || 4000;
        el.hidden = !(typeof price === 'number' && price >= min);
      });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var d = event && event.data;
      if (!d) return;
      update(d.sectionId, d.variant ? d.variant.price : null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
